import { Box } from "@mui/material";
import {
  createFileRoute,
  Outlet,
  useMatches,
  useParams,
} from "@tanstack/react-router";

import { PageContainer } from "@/features/Profiles/ProfilesPage.styles";
import { OrionPageHeader } from "@/orion/OrionComponents/OrionPageHeader";

export const Route = createFileRoute("/_auth/sku-store/$siteId")({
  component: RouteComponent,
});

function RouteComponent() {
  const params = useParams({ strict: false });
  const matches = useMatches();

  const isSkuDetail = Boolean(
    params.skuId ?? matches.some((match) => match.routeId?.includes("$skuId")),
  );
  // The landing page renders its own top nav + collection shell (like the SKU
  // detail layout), so it opts into the full-height, header-less treatment.
  const isLanding = matches.at(-1)?.routeId === "/_auth/sku-store/$siteId/";
  const isFullShell = isSkuDetail || isLanding;

  return (
    <PageContainer
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        ...(isFullShell
          ? {
              height: "100%",
              minHeight: 0,
              overflow: "hidden",
            }
          : { minHeight: 0 }),
      }}
    >
      {!isFullShell ? (
        <OrionPageHeader breadcrumbs={[{ label: "SKU Store" }]} title="" />
      ) : null}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minWidth: 0,
          minHeight: 0,
        }}
      >
        <Outlet />
      </Box>
    </PageContainer>
  );
}
